/**
 * 8D 每一步到底填什么。
 *
 * 原来九个步骤共用一个「内容说明 *」的单行输入框，选了 D4 也没有任何提示——
 * 和当初「5Why 里没写清怎么写 5Why」是同一个毛病（试用反馈 8/14）。
 *
 * 每条都给了东禾自己的例子：以「出风口总成拨叉漏装」贯穿 D0–D8，
 * 那是库里唯一走到 D5 的真实案例，比编的例子可信。
 */
export interface EightDStepGuide {
  /** D0–D8 */
  code: string;
  /** 这一步的标准名称 */
  name: string;
  /** 这一步要答什么 */
  help: string;
  /** 输入框里的例子 */
  placeholder: string;
}

export const EIGHT_D_STEPS: readonly EightDStepGuide[] = [
  {
    code: 'D0',
    name: '应急反应',
    help: '发现问题当天先做了什么止血动作，防止不良继续流出。',
    placeholder: '例：当班停线，已装配的 3 箱总成全部拦下，通知客户端暂停上线。',
  },
  {
    code: 'D1',
    name: '成立小组',
    help: '谁负责这件事：组长 + 各口子的人（工艺/质量/生产/设计），写清姓名和分工。',
    placeholder: '例：组长 张三（质量）；工艺 李四；装配班长 王五；设计 赵六。',
  },
  {
    code: 'D2',
    name: '问题描述',
    help: '用 5W2H 说清楚：什么零件、什么缺陷、在哪发现、什么时候、多少件、占比多少。',
    placeholder: '例：X04C 三排出风口总成缺 1 个拨叉，6/12 装配线 GP12 工位发现，当批 800 件中 3 件，0.375%。',
  },
  {
    code: 'D3',
    name: '围堵措施（临时）',
    help: '在找到根因之前，怎么保证不良不流到客户。注意这是**临时**手段，不是最终对策。',
    placeholder: '例：GP12 增加 100% 目视全检；库存 5 箱全部返检；已发货批次通知客户端挑选。',
  },
  {
    code: 'D4',
    name: '根本原因分析',
    help: '答「为什么会发生」，要追到管理/体系层面，不要停在「操作工不小心」。5Why 的结论写在这里。',
    placeholder: '例：拨钮组件装配为纯人工操作，工位没有防错装置也没有检测手段，操作工疲劳或分心即造成漏装。',
  },
  {
    code: 'D5',
    name: '永久纠正措施',
    help: '针对 D4 的根因，改什么才能让它不再发生。要落到具体的装置、参数、文件。',
    placeholder: '例：制作 4 个专用防错盘，拨钮组件逐个放入仿形凹槽，上 CCD 检测数量，NG 停线。',
  },
  {
    code: 'D6',
    name: '效果验证',
    help: '措施上线后怎么证明有效：测什么、测多少、判据是什么、连续几批合格。',
    placeholder: '例：连续 3 批共 2400 件，CCD 检出漏装 0 件，GP12 抽检 200 件无漏装，判定有效。',
  },
  {
    code: 'D7',
    name: '防止再发（横向展开）',
    help: '同类零件、同类工位有没有一样的风险；把措施写进哪份文件（作业指导书 / 控制计划 / PFMEA）。',
    placeholder: '例：同工艺的前排出风口同步加装防错盘；更新 PFMEA 与控制计划，纳入首件点检清单。',
  },
  {
    code: 'D8',
    name: '小组总结与关闭',
    help: '结论、经验教训、对小组的确认；客户是否接受关闭。',
    placeholder: '例：6/30 客户确认关闭；经验：人工装配工位必须评估防错，已列入新项目 DFM 检查项。',
  },
];

const BY_CODE = new Map(EIGHT_D_STEPS.map((step) => [step.code, step]));

export function eightDStep(code: string): EightDStepGuide | null {
  return BY_CODE.get(String(code ?? '').trim().toUpperCase()) ?? null;
}

/** 下拉里显示「D4 根本原因分析」，光看 D4 谁也想不起来是哪一步 */
export function eightDLabel(code: string): string {
  const step = eightDStep(code);
  return step ? `${step.code} ${step.name}` : code;
}
